import { NavLink } from 'react-router';

import { useChatBottomOffset } from '~domains/chat';

import { Typography } from '@breezeventures/ui-kit/typography';
import cn from 'classnames';

import { useNavigationItems } from './lib';

export const BottomNavigation = () => {
  const tabs = useNavigationItems();
  const navRef = useChatBottomOffset<HTMLElement>();

  return (
    <nav
      ref={navRef}
      className={cn(
        `
          fixed right-0 bottom-0 left-0 z-50 min-h-bottom-nav-height border-t
          border-neutral-200 bg-white px-1 pt-3
        `
      )}
      style={{
        paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom, 0px))',
      }}
    >
      <div className="flex w-full justify-center">
        {tabs.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={label}
            to={to}
            className={`flex flex-1 shrink-0 flex-col items-center gap-1`}
          >
            {({ isActive: active }) => (
              <div className={cn({ 'opacity-50': !active })}>
                <div className="mb-1 flex w-full items-center justify-center">
                  <Icon className={cn('size-6')} />
                </div>
                <Typography.Text size="2xs">{label}</Typography.Text>
              </div>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
